<template>
    <div class="stepbar">
        <Steps :current="current">
            <Step :title="item.name"
                  :content="item.content"
                  v-for="item in steps"
                  :key="item.id"
                  @click.native="toggleStep(item)"
                  :style="item.style"></Step>
        </Steps>
    </div>
</template>
<script>
export default {
    name: 'stepbar',
    data () {
        return {
        }
    },
    props: ['steps', 'current'],
    watch: {
        steps (val) {
            this.init()
        }
    },
    created () {
        this.init()
    },
    methods: {
        toggleStep: function (item) {
            // 默认允许点击
            if (item.isClick === undefined) {
                item.isClick = true
            }
            if (item.isClick) {
                this.$emit('toggleStep', item.step)
            }
        },
        init () {
            if (this.steps.length > 0) {
                for (let i = 0; i < this.steps.length; i++) {
                    if (i === this.steps.length - 1) {
                        this.steps[i].style = {
                            width: 'initial'
                        }
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
.stepbar {
    .ivu-steps {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        .ivu-steps-head {
            background: #f5f6f7 !important;
        }
        .ivu-steps-title {
            background: #f5f6f7 !important;
        }
        .ivu-steps-head-inner {
            width: 24px;
            height: 24px;
            line-height: 22px;
            .ivu-steps-icon.ivu-icon-ios-checkmark-empty {
                line-height: 22px;
            }
        }
    }
    .ivu-steps-title {
        line-height: 24px;
        margin-bottom: 0px;
        font-weight: 500;
    }
}
.ivu-steps-horizontal {
    .ivu-steps-status-process {
        .ivu-steps-head-inner {
            border: 1px solid #1ebd62;
            background-color: #1ebd62;
        }
        .ivu-steps-title {
            color: #3498dc !important;
            font-weight: 500;
        }
    }
    .ivu-steps-status-finish {
        .ivu-steps-head-inner {
            background-color: #1ebd62 !important;
            border-color: #1ebd62 !important;
            .ivu-steps-icon {
                color: #fff !important;
            }
        }
        .ivu-steps-tail > i:after {
            background: #1ebd62 !important;
        }
        .ivu-steps-item.ivu-steps-status-process {
            .ivu-steps-head-inner {
                border: 1px solid #1ebd62;
                background-color: #1ebd62;
            }
            .ivu-steps-title {
                color: #1ebd62;
                font-weight: 500;
            }
        }
        .ivu-steps-title {
            background: #f5f6f7 !important;
            color: #1ebd62 !important;
            font-weight: 400;
        }

        .ivu-steps-item.ivu-steps-status-wait {
            .ivu-steps-head-inner {
                background-color: #cccccc !important;
                span {
                    color: #fff !important;
                }
            }
            .ivu-steps-title {
                color: #c2c2c2;
                font-weight: 300;
            }
        }
    }
}
.no-shadow {
    .ivu-steps {
        .ivu-steps-head {
            background: #fff !important;
        }
        .ivu-steps-title {
            background: #fff !important;
        }
    }
}
</style>
